import React, { useEffect } from 'react'
import { registerClientTopic } from '../firebase/obj/notificationTopic'

export default function PushNotificationContainer({ user, topic }) {

    useEffect(() => {
        if (user) {
            handleNotification()
        }
    }, [user])

    const handleNotification = () => {
        const _topic = {
            id: user.uid,
            token: '',
            topic: topic?.replaceAll('@', '_') || user.uid,
            userEmail: user.email,
            userId: user.uid,
            user: user.displayName || '',
            granted: new Date()
        }

        if (!("Notification" in window)) {
            // Check if the browser supports notifications
            alert("This browser does not support desktop notification");
        } else if (Notification.permission === "granted") {
            // Check whether notification permissions have already been granted;
            // if so, create a notification
            //const notification = new Notification("Hi there!")
            registerClientTopic(_topic)
        } else if (Notification.permission !== "denied") {
            // We need to ask the user for permission
            Notification.requestPermission().then((permission) => {
                // If the user accepts, let's create a notification
                if (permission === "granted") {
                    registerClientTopic(_topic)
                }
            })
        }
    }


    return (
        <></>
    )
}
